import { render, staticRenderFns } from "./DashboardGridFolders.vue?vue&type=template&id=0b97baa8"
import script from "./DashboardGridFolders.vue?vue&type=script&lang=js"
export * from "./DashboardGridFolders.vue?vue&type=script&lang=js"
import style0 from "./DashboardGridFolders.vue?vue&type=style&index=0&id=0b97baa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports